import React, { Component, ReactNode } from 'react';
import MobileVirtualRoomNew from './MobileVirtualRoomNew';
import type { MobileVirtualRoomProps } from './MobileVirtualRoomNew';

interface Props extends MobileVirtualRoomProps {}

interface State {
  hasError: boolean;
  error: Error | null;
}

class MobileVirtualRoomWrapper extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('[Mobile VR Wrapper] Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="fixed inset-0 bg-red-900 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full">
            <h2 className="text-red-800 font-bold text-xl mb-4">❌ Error Loading Room</h2>
            <div className="bg-red-50 p-4 rounded mb-4 text-sm">
              <p className="text-red-900 font-mono break-words">
                {this.state.error?.message || 'Unknown error'}
              </p>
            </div>
            <p className="text-gray-600 text-sm mb-4">
              Stack: {this.state.error?.stack?.substring(0, 200)}...
            </p>
            <button
              onClick={this.props.onClose}
              className="w-full px-4 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 font-semibold"
            >
              Close and Go Back
            </button>
          </div>
        </div>
      );
    }

    return <MobileVirtualRoomNew {...this.props} />;
  }
}

export default MobileVirtualRoomWrapper;
